import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { GetCampaignContentFnResponse } from '../types/campaign';
import { GetCampaignContent } from '../helpers/get-campaign-content';

interface GetCampaignContentForOfferFnPayload {
    campaignId: string;
}

export type GetCampaignContentForOfferFn = (
    payload: GetCampaignContentForOfferFnPayload,
) => Promise<GetCampaignContentFnResponse>;

export function initGetCampaignContentForOfferFn({
    dependencies,
    locale,
}: DomainInitPayload): GetCampaignContentForOfferFn {
    return async ({ campaignId }: GetCampaignContentForOfferFnPayload) => {
        return await GetCampaignContent(dependencies, {
            campaignId,
            locale,
        });
    };
}
